import type { IntlShape } from 'react-intl'
import type { TripListStatus, TripListStatusValue } from './tripListTypes'

const EDITABLE_STATUS_OPTIONS: ReadonlyArray<TripListStatusValue> = [
  'IDEA',
  'NOT_BOOKED',
  'BOOKED',
]

const BOOKED_STATUS_OPTIONS: ReadonlyArray<TripListStatusValue> = [
  'BOOKED',
]

export function getTripListStatusLabel(intl: IntlShape, value: TripListStatusValue): string {
  if (value === 'BOOKED') {
    return intl.formatMessage({
      id: 'dsjKlUcoW3tb6U9N7vAr',
      defaultMessage: 'Booked',
      description: 'Status label for trip planner list rows that are already booked',
    })
  }

  if (value === 'IDEA') {
    return intl.formatMessage({
      id: 'WttgNcfcl0cPQu_a0XOe',
      defaultMessage: 'Idea',
      description: 'Status label for trip planner list rows that are trip ideas',
    })
  }

  return intl.formatMessage({
    id: 'hKZyU0u0O8nDud2pEQyI',
    defaultMessage: 'Not booked',
    description: 'Status label for trip planner list rows that are not booked yet',
  })
}

function getTripListStatusOptions(
  isBooked: boolean,
): ReadonlyArray<TripListStatusValue> {
  if (isBooked) return BOOKED_STATUS_OPTIONS

  return EDITABLE_STATUS_OPTIONS
}

export function getTripListStatusTone(value: TripListStatusValue): TripListStatus['tone'] {
  if (value === 'IDEA') return 'idea'
  return value === 'BOOKED' ? 'positive' : 'neutral'
}

export function getTripListStatus(
  intl: IntlShape,
  status: TripListStatusValue,
  isBooked: boolean,
): TripListStatus {
  const value = isBooked ? 'BOOKED' : status

  return {
    value,
    label: getTripListStatusLabel(intl, value),
    tone: getTripListStatusTone(value),
    isEditable: !isBooked,
    options: getTripListStatusOptions(isBooked),
  }
}
